import React from 'react';
import { CheckCircleFilled } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';

type Props = {
  didNotTakeAnything: boolean;
};

const AbandonedBusinessSuccessScreen: React.FC<Props> = ({ didNotTakeAnything }) => {
  const { t } = useTranslate();

  return (
    <div className='ab-success-wrapper'>
      <div className='success-icon-wrapper'>
        <CheckCircleFilled style={{ fontSize: 72, color: '#8dbc9a' }} />
      </div>
      <div className='success-title'>{t('Thank you!')}</div>
      <div className='success-subtitle'>
        {didNotTakeAnything
          ? t(
              'Your response has been recorded. Our team will review your feedback shortly.',
            )
          : t(
              'Your purchase has been completed successfully. Your account has been restored.',
            )}
      </div>
    </div>
  );
};

export default AbandonedBusinessSuccessScreen;

